import { CategoryAndTag } from "api/generated/model";

export function matchesCategoryAndTagFilterFn(
    tags: Record<string, string[]>,
    filterValue: CategoryAndTag[]
): boolean {
    if (!filterValue || filterValue.length === 0) {
        return true;
    }
    // Group filterValue by category implementing AND logic between categories
    const tagsByCategory: Record<string, Set<string>> = {};
    for (const { categoryName, tagName } of filterValue) {
        if (!tagsByCategory[categoryName]) {
            tagsByCategory[categoryName] = new Set();
        }
        tagsByCategory[categoryName].add(tagName);
    }
    // For each category in the filter, the row must have at least one matching tag (OR logic within category)
    return Object.entries(tagsByCategory).every(([category, tagSet]) => {
        const rowTags = tags[category] || [];
        return rowTags.some((tag) => tagSet.has(tag));
    });
}
